export enum NotificationLimitTypeEnum {
    PerHour = 0,
    PerShift = 1
}
